import _regeneratorRuntime from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { ExternalInteractorBase, drawLine, gradient, isInArray } from "tsparticles-engine";

function drawConnectLine(context, width, lineStyle, begin, end) {
  context.save();
  drawLine(context, begin, end);
  context.lineWidth = width;
  context.strokeStyle = lineStyle;
  context.stroke();
  context.restore();
}

function lineStyle(container, ctx, p1, p2) {
  var options = container.actualOptions,
      connectOptions = options.interactivity.modes.connect;
  return gradient(ctx, p1, p2, connectOptions.links.opacity);
}

function drawConnection(container, p1, p2) {
  container.canvas.draw(function (ctx) {
    var _a;

    var ls = lineStyle(container, ctx, p1, p2);

    if (!ls) {
      return;
    }

    var pos1 = p1.getPosition(),
        pos2 = p2.getPosition();
    drawConnectLine(ctx, (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, ls, pos1, pos2);
  });
}

export var Connector = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Connector, _ExternalInteractorBa);

  var _super = _createSuper(Connector);

  function Connector(container) {
    _classCallCheck(this, Connector);

    return _super.call(this, container);
  }

  _createClass(Connector, [{
    key: "clear",
    value: function clear() {}
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var container, options, mousePos, distance, query, i, _iterator, _step, p1, pos1, _iterator2, _step2, p2, pos2, distMax, xDiff, yDiff;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions;

                if (!(options.interactivity.events.onHover.enable && container.interactivity.status === "mousemove")) {
                  _context.next = 9;
                  break;
                }

                mousePos = container.interactivity.mouse.position;

                if (mousePos) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                distance = Math.abs(container.retina.connectModeRadius), query = container.particles.quadTree.queryCircle(mousePos, distance, function (p) {
                  return _this.isEnabled(p);
                });
                i = 0;
                _iterator = _createForOfIteratorHelper(query);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    p1 = _step.value;
                    pos1 = p1.getPosition();
                    _iterator2 = _createForOfIteratorHelper(query.slice(i + 1));

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        p2 = _step2.value;
                        pos2 = p2.getPosition(), distMax = Math.abs(container.retina.connectModeDistance), xDiff = Math.abs(pos1.x - pos2.x), yDiff = Math.abs(pos1.y - pos2.y);

                        if (xDiff < distMax && yDiff < distMax) {
                          drawConnection(container, p1, p2);
                        }
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }

                    ++i;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _a;

      var container = this.container,
          mouse = container.interactivity.mouse,
          events = ((_a = particle === null || particle === void 0 ? void 0 : particle.interactivity) !== null && _a !== void 0 ? _a : container.actualOptions.interactivity).events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      return isInArray("connect", events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Connector;
}(ExternalInteractorBase);